import React from 'react';
import PropTypes from 'prop-types';
import ConnectedKnowledge from './ConnectedKnowledge';

// TODO: Move to react-viewerbase

function KnowledgeRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedKnowledge />;
}

KnowledgeRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default KnowledgeRouting;
